import * as R from 'ramda';
import { CaseGranulometry } from '../../../CaseGranulometry';
import { getLevelParkingsCount } from '../../../../levels/queries/basementLevels/counts/getBasementLevelParkingsCount';
import { getCaseBasementLevels } from '../../levels/getCaseBasementLevels';

export const getCaseParkingSectionsCount = (caseGranulometry: CaseGranulometry): number =>
  R.sum(getCaseBasementLevels(caseGranulometry).map(getLevelParkingsCount));
